<template>
  <v-container>
    <h1>User Data</h1>
    <br>
    <v-card>
      <v-card-title class="blue">
        <span class="headline white--text">Details</span>
        <v-spacer />
      </v-card-title>
      <v-card-text class="px-0 py-0">
        <v-alert
          v-if="error"
          :value="error"
          type="error"
          color="error"
        >
          {{ error }}
        </v-alert>
        <user-detail-component
          v-if="isLoadUser && user"
          :user="user"
          :cognito-user="cognitoUser"
          :cognito-user-pool-data="cognitoUserPoolData"
          :terms-and-conditions-data="termsAndConditionsData"
          :on-change-user="onChangeUser"
          :get-data="_getOnboardingUserById"
        />
        <v-layout
          v-if="!isLoadUser"
          justify-center
        >
          <div class="my-3">
            <v-progress-circular
              :size="50"
              color="primary"
              indeterminate
            />
          </div>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import _ from 'lodash';
import { mapActions } from 'vuex';
import { OnboardingUserDetailComponent } from '@/components/users';

export default {
  name: 'OnboardingUserDetails',
  components: {
    'user-detail-component': OnboardingUserDetailComponent,
  },
  data() {
    return {
      user: null,
      isLoadUser: false,
      cognitoUserPoolData: null,
      termsAndConditionsData: null,
      error: null,
    };
  },
  async mounted() {
    await this._getOnboardingUserById();
  },
  methods: {
    ...mapActions([
      'getOnboardingUserById',
    ]),
    async _getOnboardingUserById() {
      this.isLoadUser = false;
      try {
        this.error = null;
        const response = await this.getOnboardingUserById(this.$route.params.id);
        this.user = _.get(response, 'userMetaData.data.naturalUser') || {};
        if (!this.user && response.cognitoUserPoolData && response.congnitoUserData) {
          throw new Error('No user found');
        }
        this.user.id = this.$route.params.id;
        this.cognitoUser = response.congnitoUserData || {};
        this.cognitoUser.id = this.$route.params.id;
        this.cognitoUserPoolData = response.cognitoUserPoolData || {};
        this.cognitoUserPoolData.id = this.$route.params.id;
        this.termsAndConditionsData = response.termsAndConditionsData || {};
        this.termsAndConditionsData.id = this.$route.params.id;
        this.isLoadUser = true;
      } catch (error) {
        console.error(error);
        this.error = `Error getting user info ${this.$route.params.id}`;
        this.user = null;
        this.cognitoUser = {};
        this.cognitoUserPoolData = {};
        this.termsAndConditionsData = {};
        this.isLoadUser = true;
      }
    },
    async onChangeUser(data) {
      this.user[data.name] = _.isObjectLike(this.user[data.name]) ?
        { ...this.user[data.name], ...data.value } : data.value;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/registrations/RegistrationDetail.vue